import { routePaths } from "./navigation";

export type BusinessModuleId = "global" | "retail" | "wholesale" | "online" | "warehouse" | "expenses";

export interface ModuleNavLeaf {
    id: string;
    label: string;
    href?: string;
    description?: string;
    children?: ModuleNavLeaf[];
}

export interface ModuleNavGroup {
    id: BusinessModuleId;
    label: string;
    children: ModuleNavLeaf[];
}

/** Фаза 1: дърво в страничното меню; вътрешността на екраните остава непроменена. */
export const moduleNavTree: ModuleNavGroup[] = [
    {
        id: "global",
        label: "Глобално",
        children: [
            {
                id: "global-admin",
                label: "Потребители и роли",
                href: routePaths.adminAccess,
                description: "Администрация на достъп, роли и права.",
            },
            {
                id: "global-messages",
                label: "Съобщения",
                href: routePaths.messages,
                description: "Вътрешен чат между CRM потребители.",
            },
        ],
    },
    {
        id: "retail",
        label: "Търговия на дребно - Магазини ",
        children: [
            {
                id: "retail-cockpit",
                label: "Продажби ",
                href: routePaths.retailCockpit,
                description: "Магазини — 10 дашборда за продажби, поток, брак и акции.",
            },
            {
                id: "retail-clients-frequency",
                label: "Доклад честота",
                href: routePaths.retailFrequency,
                description: "Честота на покупки и клиентски поток по магазин.",
            },
            {
                id: "retail-percent-targets",
                label: "Цели - въвеждане",
                href: routePaths.retailPercentTargets,
                description: "Задаване на % план и % марж по магазин и период.",
            },
            {
                id: "retail-defects-sliven",
                label: "Брак към м-н Сливен",
                href: routePaths.retailDefectsSliven,
                description: "Документи за брак  от магазините към Сливен.",
            },
            {
                id: "retail-loyalty",
                label: "Червена карта",
                href: routePaths.loyalty,
                description: "Издаване, статус и нива на лоялност.",
            },
            {
                id: "retail-clients-registry",
                label: "Клиенти — регистър",
                href: `${routePaths.clients}?channel=${encodeURIComponent("Магазин")}`,
                description: "Клиентски профили с магазинен канал.",
            },
            {
                id: "retail-messages",
                label: "Съобщения",
                href: routePaths.messages,
                description: "Вътрешен чат между CRM потребители.",
            },
        ],
    },
    {
        id: "wholesale",
        label: "Търговия на едро",
        children: [
            {
                id: "wholesale-clients",
                label: "Клиенти",
                href: `${routePaths.clients}?channel=${encodeURIComponent("Expo")}`,
                description: "Клиентски профили с B2B канал.",
            },
            {
                id: "wholesale-b2b",
                label: "Фирми и портфолио",
                href: routePaths.b2b,
                description: "B2B фирми, кредит и Expo портфолио.",
            },
            {
                id: "wholesale-suppliers",
                label: "Доставчици",
                href: routePaths.wholesaleSuppliers,
                description: "Доставчици и контакти за търговия на едро.",
            },
            {
                id: "wholesale-promotions",
                label: "Акции",
                href: routePaths.wholesalePromotions,
                description: "Expo ценови акции и резултати.",
            },
            {
                id: "wholesale-orders",
                label: "Поръчки",
                href: `${routePaths.orders}?channel=Expo`,
                description: "Поръчки от търговия на едро (Expo).",
            },
            {
                id: "wholesale-traders-analytics",
                label: "Анализи — търговци",
                href: `${routePaths.bi}?tab=traders`,
                description: "Ранкинг и резултати на търговци.",
            },
            {
                id: "wholesale-campaigns",
                label: "Управление на кампании",
                href: routePaths.campaigns,
                description: "Кампании, аудитории и шаблони (табове в екрана).",
            },
            {
                id: "wholesale-messages",
                label: "Съобщения",
                href: routePaths.messages,
                description: "Вътрешен чат между CRM потребители.",
            },
        ],
    },
    {
        id: "online",
        label: "Онлайн",
        children: [
            {
                id: "online-cockpit",
                label: "Продажби",
                href: routePaths.onlineCockpit,
                description: "Онлайн продажби — само интернет магазин (обект 9).",
            },
            {
                id: "online-messages",
                label: "Съобщения",
                href: routePaths.messages,
                description: "Вътрешен чат между CRM потребители.",
            },
        ],
    },
    {
        id: "warehouse",
        label: "Склад",
        children: [
            {
                id: "warehouse-dashboard",
                label: "Контролен център",
                href: routePaths.dashboard,
                description: "Омниканален преглед на клиенти, поръчки и сигнали.",
            },
            {
                id: "warehouse-workspace",
                label: "Работно пространство",
                href: routePaths.dashboardWorkspace,
                description: "Интеграции, checkout identity и оперативни опашки.",
            },
            {
                id: "warehouse-orders",
                label: "Поръчки и поток",
                href: routePaths.orders,
                description: "Статусна дъска и подготовка.",
            },
            {
                id: "warehouse-items",
                label: "Артикули",
                href: routePaths.orderItems,
                description: "Редове по артикули за комплектоване.",
            },
            {
                id: "warehouse-messages",
                label: "Съобщения",
                href: routePaths.messages,
                description: "Вътрешен чат между CRM потребители.",
            },
        ],
    },
    {
        id: "expenses",
        label: "Разходи",
        children: [
            {
                id: "expenses-transport",
                label: "Транспорт",
                href: routePaths.expensesTransport,
                description: "Отчет за гориво, амортизация и лизинг — бусове и администрация.",
            },
            {
                id: "expenses-marketing",
                label: "Маркетинг",
                href: routePaths.expensesMarketing,
                description: "Радио, листовки и банери.",
            },
            {
                id: "expenses-salaries",
                label: "Заплати",
                href: routePaths.expensesSalaries,
                description: "Заплати по екипи.",
            },
        ],
    },
];

export function flattenModuleNavLeaves(groups: ModuleNavGroup[] = moduleNavTree): ModuleNavLeaf[] {
    const leaves: ModuleNavLeaf[] = [];

    const walk = (nodes: ModuleNavLeaf[]) => {
        for (const node of nodes) {
            if (node.children?.length) {
                walk(node.children);
            } else if (node.href) {
                leaves.push(node);
            }
        }
    };

    for (const group of groups) {
        walk(group.children);
    }

    return leaves;
}

export function findModuleForLeaf(leafId: string): BusinessModuleId | null {
    for (const group of moduleNavTree) {
        if (group.children.some((child) => child.id === leafId)) {
            return group.id;
        }
    }

    return null;
}
